<template>
  <span>
    <img draggable="false" class="background_image" src="./../../assets/images/inheems/Asset 1.png" alt="">
    <img draggable="false" id="start_drawer" src="./../../assets/images/inheems/Asset 3.png">

    <span id="inheems_start_text">Inheemse dag</span>
    <img draggable="false" id="inheems_logo" src="./../../assets/images/inheems/Asset 2.png" alt="">
    <img draggable="false" @click="goToInheemsIntro()" class="clickable" id="inheems_start_btn" src="./../../assets/images/Asset 30.png" alt="">
    <img draggable="false" @click="goToStart()" class="clickable" id="inheems_quit_btn" src="./../../assets/images/Asset 58.png" alt="">
  </span>
</template>

<script>


export default {
  name: "InheemsStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToStart() {
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: false,
      });
      this.$router.push('/start');
    },
    
    goToInheemsIntro() {
      this.$router.push('/inheems/intro');
    },
  },

  computed: {}
};
</script>

<style>
  #inheems_start_btn {
    position: absolute;
    margin-top: 35%;
    left: 28%;
    width: 20%;
  }
  #inheems_quit_btn {
    position: absolute;
    margin-top: 35%;
    left: 54%;
    width: 20%;
  }
  #start_drawer {
    position: absolute;
    margin-top: 10%;
    left: 20%;
    width: 62%;
  }
  #inheems_logo {
    position: absolute;
    margin-top: 22%;
    left: 35%;
    width: 32%;
  }
  #inheems_start_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 15%;
    width: 52%;
    left: 25%;
    color: #422818;
    font-size: 7vw;
    text-align: center;
    filter: drop-shadow(0px 0px 5px #3d3d3d);
  }
</style>


